import { useMemo, useEffect,useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import 'bootstrap-icons/font/bootstrap-icons.css';
import './Global/Global.css';
import { CssBaseline, ThemeProvider } from "@mui/material";
import { createTheme } from "@mui/material/styles";
import { useSelector } from "react-redux";
import { themeSettings } from "./Global/Theme.js";
import DashboardPageLayout from './Views/Page Layout/DashboardPageLayout'
import AllServices from './Views/All Services/All Services.js';
import AccountStatement from './Views/Account Statement/AccountStatement';
import PayOnline from './Views/Payment And History/PayOnline';
import PaymentHistory from './Views/Payment And History/PaymentHistory';
import InterestRateMovement from './Views/Interest Rate Movement/InterestRateMovement';
import AccountSummary from './Views/Account Summary/AccountSummary';
import ProvisionalInterestCalculation from './Views/Provisional Interest Calculation/ProvisionalInterestCalculation';
import RegularPaymentMode from './Views/Regular Payment Mode/Regularpaymentmode';
import DashboardPage from './Views/Dashboard/DashboardPage';
import TransactionDetail from './Views/Transaction Details/TransactionDetail';
import PendingVerification from './Views/Pending Verification/PendingVerification';
import ProfilePage from './Views/Profile/ProfilePage';
import Faq from './Views/FAQ/Faq';
import SessionExpired from './Views/Session Expired/SessionExpired';
import PaymentFailure from './Views/Payment Failure/PaymentFailure';
import PaymentAfterSOA from './Views/Payment Success/PaymentAfterSOA';
import { FaqOuter } from './Views/FAQ Outer/FaqOuter';
import Profileouter from './Views/Proflie Outer/Profileouter';
import PageNotFound from './Views/Page not found/PageNotfound.js'
import InterestCalculator from './Views/Interest Calculator/emiCalculatorPage.js';
import Tc from './Views/Terms and Conditions/T&C.js';
import CusomerLogin from '../src/Views/LoginNew/CustomerLogin.js'
import ComplaintForm from './Views/ComplaintWeb/ComplaintWeb.js';
import ComplaintFormForMobile from './Views/ComplaintMobile/Complaintmobile.js';



function App() {

  const mode = useSelector((state) => state.mode);
  const theme = useMemo(() => createTheme(themeSettings(mode)), [mode]);
      const [devToolsOpen, setDevToolsOpen] = useState(false);
 
 
 
  function isMobile() {
    return /Android|iPhone|iPad|iPod|Opera Mini|IEMobile/i.test(
      navigator.userAgent,
    );
  }
 
  function isDevToolsOpen() {
    if (isMobile()) return false; // Skip check entirely on mobile
 
    const threshold = 160;
    return (
      window.outerWidth - window.innerWidth > threshold ||
      window.outerHeight - window.innerHeight > threshold
    );
  }
 
  useEffect(() => {
    const detectDevTools = () => {
      const threshold = 160;
 
      if (
        window.outerWidth - window.innerWidth > threshold ||
        window.outerHeight - window.innerHeight > threshold ||
        window.screenX < -100 ||
        window.screenY < -100
      ) {
        setDevToolsOpen(true);
        setDevToolsOpen(false);
      }
    };
 
    const interval = setInterval(detectDevTools, 600);
 
    // Also listen for resize (helps when switching to mobile view)
    window.addEventListener('resize', detectDevTools);
 
    return () => {
      clearInterval(interval);
      window.removeEventListener('resize', detectDevTools);
    };
  }, []);
 
  // for restricting inspect
  useEffect(() => {
    const handleContextMenu = (e) => e.preventDefault();
 
    const handleKeyDown = (e) => {
      if (
        e.ctrlKey &&
        e.shiftKey &&
        ["I", "J", "C", "K"].includes(e.key.toUpperCase())
      ) {
        e.preventDefault();
      }
 
      // Ctrl+U (View Source)
      if (e.ctrlKey && e.key === "u") {
        e.preventDefault();
      }
 
      // F12 (DevTools)
      if (e.key === "F12") {
        e.preventDefault();
      }
    };
 
    document.addEventListener("contextmenu", handleContextMenu);
    document.addEventListener("keydown", handleKeyDown);
 
    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);
 
 

  useEffect(() => {
    if (mode === "dark") {
      document.body.classList.add("darkforsidebar");
    } else {
      document.body.classList.remove("darkforsidebar");
    }
  }, [mode]);




  return (
    <>
      {/* <Sidebar/> */}
      <BrowserRouter>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Routes>
            <Route exact path="/" element={<CusomerLogin />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path='/Personal-Info' element={<Profileouter />} />
            <Route path='/Session-Expired' element={<SessionExpired />} />
            <Route path='/Faq' element={< FaqOuter />} />
            <Route path='intCal' element={<InterestCalculator />} />
            <Route path='TermsAndConditions' element={<Tc />} />
            <Route path="*" element={<CusomerLogin />} />
            <Route path="chatwithus" element={<PageNotFound />} />
            <Route path="callus" element={<PageNotFound />} />
            <Route path="raiseComplaint" element={<ComplaintForm />} />
            <Route path="raiseComplaintMobile/:mbl?" element={<ComplaintFormForMobile />} />

            <Route path="/success" element={<DashboardPageLayout />}>
            <Route path="Payment-Success/:transactionId?" element={<PaymentAfterSOA />} />
              <Route path='Payment-Failure' element={<PaymentFailure />} />
              <Route index element={<AccountSummary />} />
              <Route path='Interest-rate-Movements' element={<InterestRateMovement />} />
              <Route path='Account-Statement' element={<AccountStatement />} />
              <Route path='Account-Summary' element={<AccountSummary />} />
              <Route path='Pay-Online' element={<PayOnline />} />
              <Route path='Online-Payment-History' element={<PaymentHistory />} />
              <Route path='Provisional-Interest' element={<ProvisionalInterestCalculation />} />
              <Route path='Mode-Of-Payment' element={<RegularPaymentMode />} />
              <Route path='All-Service-Request' element={<AllServices />} />
              <Route path='Transaction-Details' element={<TransactionDetail />} />
              <Route path='Pending-Verification' element={<PendingVerification />} />
              <Route path='Personal-Info' element={<ProfilePage />} />
              <Route path='Faq' element={<Faq />} />
            </Route>
          </Routes>
        </ThemeProvider>
      </BrowserRouter>
    </>
  );
};

export default App;